// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"a2111f1a","977":"aaf2d204"}[chunkId] + ".chunk.js";
};